<template>
  <div class="orderListItem">
    <div class="content" @click="handleClick">
      <div class="left">
        <div class="left-img">
          <img src="@/assets/style/loan-icon.png" alt="" />
        </div>
        <div class="left-content">
          <div class="left-top">
            <span>借款额度：</span>
            <span class="span">{{ amountFormatter(item.borrowAmount) }}元</span>
          </div>
          <div class="left-bottom">
            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div>资质审查中</div>
        <img class="icon" src="@/assets/style/phone-right-icon.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { amountFormatter } from "@/utils/utils";

export default {
  name: "orderListItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      amountFormatter,
    };
  },
  async mounted() {},
  methods: {
    handleClick() {
      this.$store.commit("setRouterFlag", "1");
      this.$router.push({
        path: "/orderDetails",
        query: {
          borrowOrderId: this.item.borrowOrderId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.orderListItem {
  padding: 18px 17px;
  margin-top: 16px;
  border-radius: 12px;
  background: linear-gradient(90deg, #ffffff 99.99%, #ddf0ff 100%);
  border: 1px solid;
  border-image: linear-gradient(
      360deg,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    )
    1 1;
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      .left-img {
        margin-right: 10px;
        display: flex;
        align-items: center;
        img {
          height: 30px;
          width: 30px;
        }
      }
      .left-content {
        display: flex;
        flex-direction: column;
        .left-top {
        }
        .left-bottom {
          color: #777777;
          font-size: 11px;
          margin-top: 5px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      color: #1d70f7;
      font-size: 12px;
      .icon {
        height: 10px;
        margin-left: 9px;
        margin-top: 3px;
      }
    }
  }
}
</style>
